import { Badge } from "@/components/ui/badge";

const classes: Record<string, string> = {
  ACTIVE: "border-primary/20 bg-primary/10 text-primary",
  APPROVED: "border-primary/20 bg-primary/10 text-primary",
  VERIFIED: "border-primary/20 bg-primary/10 text-primary",
  COMPLETED: "border-primary/20 bg-primary/10 text-primary",
  CAPTURED: "border-primary/20 bg-primary/10 text-primary",
  SUBMITTED: "border-warning/25 bg-warning/10 text-warning",
  PLANNED: "border-warning/25 bg-warning/10 text-warning",
  SANCTIONED: "border-primary/20 bg-primary/10 text-primary",
  ACKNOWLEDGED: "border-primary/20 bg-primary/10 text-primary",
  IN_PROGRESS: "border-accent/30 bg-accent/10 text-accent-foreground",
  VISITED: "border-primary/20 bg-primary/10 text-primary",
  MISSED: "border-destructive/25 bg-destructive/10 text-destructive",
  RESCHEDULED: "border-warning/25 bg-warning/10 text-warning",
  CANCELLED: "border-border bg-muted text-muted-foreground",
  PENDING: "border-warning/25 bg-warning/10 text-warning",
  RESTRICTED: "border-warning/25 bg-warning/10 text-warning",
  ARCHIVED: "border-border bg-muted text-muted-foreground",
  INACTIVE: "border-border bg-muted text-muted-foreground",
  DRAFT: "border-border bg-muted text-muted-foreground",
};

export const StatusBadge = ({ status, testId }: { status: string; testId: string }) => (
  <Badge variant="outline" className={classes[status.toUpperCase()] || "border-border bg-muted text-muted-foreground"} data-testid={testId}>
    {status.replace(/_/g, " ")}
  </Badge>
);
